//Valentine's Offer text direct static replacement

// (function () {
//   var OLD_TEXTS = [
//     "🥳 Nos soldes d'anniversaire sont en cours maintenant ! 🥳",
//     "🥳 La vente anniversaire est en cours ! 🥳"
//   ];
//  // var NEW_TEXT = "❤️ Nos soldes de Saint-Valentin sont en cours maintenant ! ❤️";
//   // var NEW_TEXT = "Nos offres de Pâques sont là 🐰🐣";
//   // var NEW_TEXT = "🕵️ Notre vente mystère de mai vient de commencer ! 🕵️";
//   //  var NEW_TEXT = "🤸🎈 Les offres Play Days sont disponibles dès maintenant 🎈👩🏼‍🤝‍👨🏽";
//   var NEW_TEXT = "🎒✨ Les Vente « Smart Start » sont officiellement lancés ✨📚";

//   function replaceText(root) {
//     var scope = root || document;

//     scope
//       .querySelectorAll("h1,h2,h3,h4,h5,h6,#seasonalSale")
//       .forEach(function (el) {
//         if (OLD_TEXTS.includes(el.textContent.trim())) {
//           el.textContent = NEW_TEXT;
//         }
//       });
//   }

//   replaceText();

//   if (window.MutationObserver) {
//     new MutationObserver(function (mutations) {
//       mutations.forEach(function (m) {
//         if (m.type === "childList" || m.type === "characterData") {
//           replaceText(m.target.nodeType === 1 ? m.target : m.target.parentNode);
//         }
//       });
//     }).observe(document.body, {
//       childList: true,
//       subtree: true,
//       characterData: true
//     });
//   }
// })();

(function () {
  var currentDate = new Date();
  var year = currentDate.getFullYear();

  // Active period: October 19 to October 25 (inclusive)
  var startDate = new Date(year, 9, 19, 0, 0, 0);
  var endDate = new Date(year, 9, 26, 0, 0, 0);

  // Stop completely outside the active period
  if (currentDate < startDate || currentDate >= endDate) {
    return;
  }

  var OLD_TEXTS = [
    "🥳 Nos soldes d'anniversaire sont en cours maintenant ! 🥳",
    "🥳 La vente anniversaire est en cours ! 🥳"
  ];

  var NEW_TEXT =
    "🤸🎈 Les Big Kiddo Days sont officiellement lancés ! 🎈👩🏼‍🤝‍👨🏽";

  function replaceText(root) {
    var scope = root || document;

    if (scope.nodeType === 1 &&
        scope.matches("h1,h2,h3,h4,h5,h6,#seasonalSale") &&
        OLD_TEXTS.includes(scope.textContent.trim())) {
      scope.textContent = NEW_TEXT;
    }

    if (scope.querySelectorAll) {
      scope
        .querySelectorAll("h1,h2,h3,h4,h5,h6,#seasonalSale")
        .forEach(function (el) {
          if (OLD_TEXTS.includes(el.textContent.trim())) {
            el.textContent = NEW_TEXT;
          }
        });
    }
  }

  replaceText();

  if (window.MutationObserver) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.type === "childList" || m.type === "characterData") {
          var target =
            m.target.nodeType === 1
              ? m.target
              : m.target.parentNode;

          if (target) {
            replaceText(target);
          }
        }
      });
    }).observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }
})();


// (function() {

//   // var NEW_HEADING_TEXT = "🎉 Nos promotions du Cyber Monday ont commencé ! 🥳";
//   // var NEW_HEADING_HTML = '🎉 Nos promotions du <span class="black-friday-allproducts">Cyber Monday</span> ont commencé ! 🥳';

//    var NEW_HEADING_TEXT = "🥳 Notre vente de anniversaire est en cours! 🥳";
//    var NEW_HEADING_HTML = '🥳 Notre vente de <span class="black-friday-allproducts">anniversaire</span> est en cours ! 🥳';

//   function replaceAnniversaryHeadings(root) {
//     var headings = (root || document).querySelectorAll("h1,h2,h3,h4,h5,h6");

//     headings.forEach(function(h) {
//       var txt = (h.textContent || "").trim();
//       if (!txt) return;

//       var lower = txt.toLowerCase();

//       if (
//         lower.includes("la vente anniversaire est en cours") &&
//         !h.querySelector(".black-friday-allproducts")
//       ) {
//         h.innerHTML = NEW_HEADING_HTML;
//         if (h.id === "seasonalSale") h.removeAttribute("id");
//         return;
//       }

//       if (
//         (lower.includes("aujourd'hui") || lower.includes("aujourd’hui")) &&
//         lower.includes("anniversaire") &&
//         !h.querySelector(".black-friday-allproducts")
//       ) {
//         var newText = txt.replace(
//           /c[’']est notre\s+anniversaire!?/i,
//           "c’est notre vente anniversaire"
//         );
//         newText = newText.replace(
//           /c[’']est notre vente anniversaire/i,
//           'c’est notre <span class="black-friday-allproducts">anniversaire</span> Sale'
//         );

//         newText = newText.replace(/🎉/g, "🎉").replace(/🥳/g, "🥳");

//         h.innerHTML = newText;
//         if (h.id === "seasonalSale") h.removeAttribute("id");
//         return;
//       }

//       if (txt === NEW_HEADING_TEXT && !h.querySelector(".black-friday-allproducts")) {
//         h.innerHTML = NEW_HEADING_HTML;
//         if (h.id === "seasonalSale") h.removeAttribute("id");
//       }

//     });
//   }

//   function startReplacing() {
//     replaceAnniversaryHeadings(document);

//     var attempts = 0;
//     var intervalId = setInterval(function() {
//       replaceAnniversaryHeadings(document);
//       if (++attempts > 30) clearInterval(intervalId);
//     }, 500);

//     if (window.MutationObserver) {
//       new MutationObserver(function(mutations) {
//         mutations.forEach(function(m) {
//           m.addedNodes.forEach(function(node) {
//             if (node.nodeType === 1) replaceAnniversaryHeadings(node);
//           });
//         });
//       }).observe(document.body, { childList: true, subtree: true });
//     }
//   }

//   if (document.readyState === "loading") {
//     document.addEventListener("DOMContentLoaded", startReplacing);
//   } else {
//     startReplacing();
//   }

// })();

// (function() {

//   // var NEW_HEADING_TEXT = "🎉 Nos promotions du Cyber Monday ont commencé ! 🥳";
//   // var NEW_HEADING_HTML = '🎉 Nos promotions du <span class="black-friday-allproducts">Cyber Monday</span> ont commencé ! 🥳';

//    var NEW_HEADING_TEXT = "🎄 Notre vente de Noël est en cours ! 🎅";
//    var NEW_HEADING_HTML = '🎄 Notre vente de <span class="black-friday-allproducts">Noël</span> est en cours ! 🎅';

//   function replaceAnniversaryHeadings(root) {
//     var headings = (root || document).querySelectorAll("h1,h2,h3,h4,h5,h6");

//     headings.forEach(function(h) {
//       var txt = (h.textContent || "").trim();
//       if (!txt) return;

//       var lower = txt.toLowerCase();

//       if (
//         lower.includes("la vente anniversaire est en cours") &&
//         !h.querySelector(".black-friday-allproducts")
//       ) {
//         h.innerHTML = NEW_HEADING_HTML;
//         if (h.id === "seasonalSale") h.removeAttribute("id");
//         return;
//       }

//       if (
//         (lower.includes("aujourd'hui") || lower.includes("aujourd’hui")) &&
//         lower.includes("anniversaire") &&
//         !h.querySelector(".black-friday-allproducts")
//       ) {
//         var newText = txt.replace(
//           /c[’']est notre\s+anniversaire!?/i,
//           "c’est notre Noël Sale"
//         );
//         newText = newText.replace(
//           /c[’']est notre Noël Sale/i,
//           'c’est notre <span class="black-friday-allproducts">Noël</span> Sale'
//         );

//         newText = newText.replace(/🎉/g, "🎄").replace(/🥳/g, "🎅");

//         h.innerHTML = newText;
//         if (h.id === "seasonalSale") h.removeAttribute("id");
//         return;
//       }

//       if (txt === NEW_HEADING_TEXT && !h.querySelector(".black-friday-allproducts")) {
//         h.innerHTML = NEW_HEADING_HTML;
//         if (h.id === "seasonalSale") h.removeAttribute("id");
//       }

//     });
//   }

//   function startReplacing() {
//     replaceAnniversaryHeadings(document);

//     var attempts = 0;
//     var intervalId = setInterval(function() {
//       replaceAnniversaryHeadings(document);
//       if (++attempts > 30) clearInterval(intervalId);
//     }, 500);

//     if (window.MutationObserver) {
//       new MutationObserver(function(mutations) {
//         mutations.forEach(function(m) {
//           m.addedNodes.forEach(function(node) {
//             if (node.nodeType === 1) replaceAnniversaryHeadings(node);
//           });
//         });
//       }).observe(document.body, { childList: true, subtree: true });
//     }
//   }

//   if (document.readyState === "loading") {
//     document.addEventListener("DOMContentLoaded", startReplacing);
//   } else {
//     startReplacing();
//   }

// })();
